/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { OneOfPropertyOfPtw100InternalAreaOptions } from './OneOfPropertyOfPtw100InternalAreaOptions';
import {
    OneOfPropertyOfPtw100InternalAreaOptionsFromJSON,
    OneOfPropertyOfPtw100InternalAreaOptionsFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaOptionsToJSON,
} from './OneOfPropertyOfPtw100InternalAreaOptions';
import type { Ptw100InternalArea } from './Ptw100InternalArea';
import {
    Ptw100InternalAreaFromJSON,
    Ptw100InternalAreaFromJSONTyped,
    Ptw100InternalAreaToJSON,
} from './Ptw100InternalArea';

/**
 * 
 * @export
 * @interface OneOfPropertyOfPtw100InternalArea
 */
export interface OneOfPropertyOfPtw100InternalArea {
    /**
     * 
     * @type {Ptw100InternalArea}
     * @memberof OneOfPropertyOfPtw100InternalArea
     */
    defaultValue?: Ptw100InternalArea;
    /**
     * 
     * @type {Ptw100InternalArea}
     * @memberof OneOfPropertyOfPtw100InternalArea
     */
    value?: Ptw100InternalArea;
    /**
     * 
     * @type {OneOfPropertyOfPtw100InternalAreaOptions}
     * @memberof OneOfPropertyOfPtw100InternalArea
     */
    options?: OneOfPropertyOfPtw100InternalAreaOptions | null;
    /**
     * 
     * @type {string}
     * @memberof OneOfPropertyOfPtw100InternalArea
     */
    $type?: OneOfPropertyOfPtw100InternalAreaTypeEnum;
}


/**
 * @export
 */
export const OneOfPropertyOfPtw100InternalAreaTypeEnum = {
    PtwDomainItemTypeCatalogInfrastructurePropertyTypesOneOfProperty1PtwDomainItemTypeCatalogInfrastructureDescriptionsEnumsPtw100InternalAreaPtwDomainItemTypeCatalogInfrastructurePtwDomainItemTypeCatalogInfrastructure: 'Ptw.DomainItemTypeCatalog.Infrastructure.PropertyTypes.OneOfProperty`1[[Ptw.DomainItemTypeCatalog.Infrastructure.Descriptions.Enums.Ptw100InternalArea, Ptw.DomainItemTypeCatalog.Infrastructure]], Ptw.DomainItemTypeCatalog.Infrastructure'
} as const;
export type OneOfPropertyOfPtw100InternalAreaTypeEnum = typeof OneOfPropertyOfPtw100InternalAreaTypeEnum[keyof typeof OneOfPropertyOfPtw100InternalAreaTypeEnum];



/**
 * Check if a given object implements the OneOfPropertyOfPtw100InternalArea interface.
 */
export function instanceOfOneOfPropertyOfPtw100InternalArea(value?: unknown): value is OneOfPropertyOfPtw100InternalArea {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(OneOfPropertyOfPtw100InternalAreaTypeEnum)[0];
}

export function OneOfPropertyOfPtw100InternalAreaFromJSON(json: any): OneOfPropertyOfPtw100InternalArea {
    return OneOfPropertyOfPtw100InternalAreaFromJSONTyped(json, false);
}

export function OneOfPropertyOfPtw100InternalAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OneOfPropertyOfPtw100InternalArea {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultValue': json['defaultValue'] == null ? undefined : Ptw100InternalAreaFromJSON(json['defaultValue']),
        'value': json['value'] == null ? undefined : Ptw100InternalAreaFromJSON(json['value']),
        'options': json['options'] == null ? undefined : OneOfPropertyOfPtw100InternalAreaOptionsFromJSON(json['options']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function OneOfPropertyOfPtw100InternalAreaToJSON(value?: OneOfPropertyOfPtw100InternalArea | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultValue': Ptw100InternalAreaToJSON(value['defaultValue']),
        'value': Ptw100InternalAreaToJSON(value['value']),
        'options': OneOfPropertyOfPtw100InternalAreaOptionsToJSON(value['options']),
        '$type': value['$type'],
    });
}

